var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news-detail",attrs:{"id":"e3-home"}},[_c('tg-e3-header-bar',{attrs:{"keywords":_vm.keywords,"search":_vm.search}}),_c('tg-e3-news-detail',{attrs:{"articleMain":_vm.articleMain,"channel":_vm.channel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }